window.translationsText = window.translationsText || {};
window.translationsText.stickyFilled = "Farbauswahl ansehen";
window.translationsText.buttonUnfilled = "Wähle Deine Farben";
window.translationsText.farbe = "Farbe";


function setProgressBar(total, filled) {
  const progressBarFill = document.querySelector(".progress-bar-fill");
  const percentage = (filled / total) * 100;
  progressBarFill.style.width = `${percentage}%`;

  $(
    ".color-selection__selection-container .color-selection__grid .color-selection__image"
  ).removeClass("bk-border");
  $(
    ".color-selection__selection-container .color-selection__grid .color-selection__image:not(.coladded)"
  )
    .first()
    .addClass("bk-border");
}
function updateProgress() {
  var totalFilledColor = $('.hidden-color[value!=""]').length;
  var totalToBeFilled = parseInt($("#pick-color-id").attr("custom-toshow"));
  setProgressBar(totalToBeFilled, totalFilledColor);

  $(".greyedText .selectedColor").text(totalFilledColor);

  if (totalFilledColor == totalToBeFilled) {
    $(".hidden-overlay").click();
    $("#AddToCart").removeAttr("disabled");

    $(".template-product-nailkit").addClass("allfill");
    $(".custom-fixed-footer button").removeAttr("disabled");
  } else {
    $(".template-product-nailkit").removeClass("allfill");
    setTimeout(function () {
      $("#AddToCart").attr("disabled", "true");
      $(".custom-fixed-footer button").attr("disabled", "true");
    }, 100);
  }
}

$(document).ready(function () {
  $(".color-selection__image--top").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var count = $(this).closest(".color-selection__grid-item").data("count");

    if ($(this).closest(".color-selection__grid-item").hasClass("active")) {
      $(".color-selection__grid-item.active").removeClass("active");
      $(".color-selection__selection-container").hide();

      $("body").removeClass("color-choose-active");
    } else {
      $(".color-selection__grid-item.active").removeClass("active");
      $(this).closest(".color-selection__grid-item").addClass("active");
      $(`.color-selection__selection-container`).css("display", "flex");

      $("body").addClass("color-choose-active");
    }
  });

  $(".color-selection__selection-grid-item.clickable").click(function (event) {
    if ($(this).data("disable") == undefined) {
      $(".color-selection__selection-grid-item.clickable").attr(
        "data-disable",
        true
      );
      var $file = $(this).children(".color-selection__image").data("file");
      var $colorNameData = $(this).children(".color-selection__image").data("title");
      var lastHyphenIndex = $colorNameData.lastIndexOf("-");
      var $colorName = $colorNameData.slice(0, lastHyphenIndex);
      var $variantId = $(this)
        .children(".color-selection__image")
        .data("variant");

      //lets find first unselected index instead

      var count = $('.hidden-color[value=""]:eq(0)').data("color-index"); //$(this).parent('.color-selection__selection-container').data('count');

      var totalCount = $(".color-selection__grid-item").data("total-count");

      var $input = $(`#Farbe-${count}`);

      var $img = $(`.color-selection__grid-item[data-count=${count}]`).children(
        ".color-selection__image--top"
      );
      var $title = $(
        `.color-selection__grid-item[data-count=${count}]`
      ).children(".farbe-title");
      $(`.color-selection__grid-item[data-count=${count}]`)
        .children(".color-selection__image--top")
        .find(".color-selection-ad-text")
        .remove();

      $input.val($colorNameData);
      $input.attr("variant-id", $variantId);
      $input.attr("variant-img", $file);

      $img.css("backgroundImage", `url(${$file})`);
      $title.text($colorName);
      //  $img.css('backgroundColor', '#fff');
      $img.addClass("coladded");

      updateProgress();

      setTimeout(function () {
        $(".color-selection__selection-grid-item.clickable").removeAttr(
          "data-disable"
        );
      }, 50);
    } else {
      event.stopPropagation();
    }
  });



  $("body").on("click", "#MainPaymentContainer", function (evt) {
    if ($(this).find("#AddToCart").attr("disabled") == "disabled") {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      $(".color-selection__image.color-selection__image--top.pi-1").trigger(
        "click"
      );
    }
  });
  $(".color-choose-filter").click(function (evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    $(this)
      .parents(".color-selection__selection-container")
      .find(".color-choose-filter")
      .removeClass("text--underlined");
    $(this).addClass("text--underlined");

    let offSet = $(this)[0].offsetLeft;
    // $('.color-filter-link-bar .link-bar__scroller').scrollLeft(offSet);

    $(".color-filter-link-bar .link-bar__scroller").animate(
      {
        scrollLeft:
          $(this).position().left +
          $(".color-filter-link-bar .link-bar__scroller").scrollLeft() -
          100,
      },
      500
    );

    var filterVal = $(this).data("tag");

    $(this)
      .parents(".color-selection__selection-container")
      .find(".color-selection__selection-grid-item.clickable")
      .hide()
      .filter("." + filterVal)
      .show();
  });

  $("body").on("click", ".custom-new-upsell", function (evt) {
    if ($(this).find(".remover_upsell").attr("disabled") == "disabled") {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      $(".color-selection__image.color-selection__image--top.pi-1").trigger(
        "click"
      );
    }
  });

  $(".color-selection__arrow.close_icon_svg").click(function (evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();

    var $parent = $(this).parents(".color-selection__grid-item");

    //lets find first unselected index instead

    var count = $parent.data("count");

    var totalCount = $(".color-selection__grid-item").data("total-count");

    var $input = $(`#Farbe-${count}`);

    var $img = $(`.color-selection__grid-item[data-count=${count}]`).children(
      ".color-selection__image--top"
    );

    $(`.color-selection__grid-item[data-count=${count}]`)
      .children(".farbe-title")
      .text(`${window.translationsText.farbe} ${count}`);

    $input.val("");
    $input.removeAttr("variant-id");
    $input.removeAttr("variant-img");
    $img.removeAttr("style");
    $img.removeClass("coladded");

    updateProgress();
  });

  document.addEventListener("variant:changed", function (event) {
    updateProgress();
  });

  $("body").click(function (event) {
    if (
      !$(event.target).is(".color-selection__selection-grid-item") &&
      !$(event.target).is(".color-selection__selection-grid-item *") &&
      !$(event.target).is(".link-bar .container") &&
      !$(event.target).is(".link-bar") &&
      !$(event.target).is(".link-bar__linklist") &&
      !$(event.target).is(".link-bar__scroller") &&
      !$(event.target).is(".link-bar__link-item") &&
      !$(event.target).is(".color-choose-filter") &&
      !$(event.target).is(".color-selection__image--top") &&
      !$(event.target).is("#MainPaymentContainer .disabled-text") &&
      !$(event.target).is("#MainPaymentContainer #AddToCart") &&
      !$(event.target).is(".color-selection-pi-text") &&
      !$(event.target).is(".color-tool-tip")
    ) {
      $(".color-selection__grid-item.active").removeClass("active");
      $(".color-selection__selection-container").hide();
      $("body").removeClass("color-choose-active");
    }
  });

  setProgressBar(
    parseInt($("#pick-color-id").attr("custom-toshow")),
    $('.hidden-color[value!=""]').length
  );
  $("#AddToCart").attr("disabled", "true");
  $("#AddToCart").append(
    `<span class='disabled-text'>${window.translationsText.buttonUnfilled}</span>`
  );
});
